"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartBoxInfo = exports.SmartBox = exports.SmartBoxDevice = void 0;
/* eslint-disable new-cap */
/* eslint-disable no-underscore-dangle */
var DeviceCharacteristic_1 = require("../common/DeviceCharacteristic");
var BatDevice_1 = __importDefault(require("../common/BatDevice"));
var sound_pattern_enum_1 = require("../features/findVape/enum/sound-pattern.enum");
var SmartBoxProfile = {
    uuid: '6cd6c8b5-e378-0109-000a-1b9740683449',
    VAPING: {
        name: 'Vaping Service',
        uuid: '6cd6c8b5-e378-0109-000a-1b9740683449',
        characteristics: [
            {
                name: DeviceCharacteristic_1.VapingCharacteristics.DEVICE_INFORMATION,
                uuid: '6cd6c8b5-e378-0109-010a-1b9740683449',
            },
            { name: DeviceCharacteristic_1.VapingCharacteristics.TIME, uuid: '6cd6c8b5-e378-0109-020a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.BATTERY, uuid: '6cd6c8b5-e378-0109-030a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.LOCK, uuid: '6cd6c8b5-e378-0109-040a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.PUFF_RECORDS, uuid: '6cd6c8b5-e378-0109-060a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.FIND_MY_VAPE, uuid: '6cd6c8b5-e378-0109-090a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.LED, uuid: '6cd6c8b5-e378-0109-0a0a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.CLOUD_CONTROL, uuid: '6cd6c8b5-e378-0109-0c0a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.HAPTIC, uuid: '6cd6c8b5-e378-0109-0d0a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.FACTORY_RESET, uuid: '6cd6c8b5-e378-0109-0b0a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.BUZZER, uuid: '6cd6c8b5-e378-0109-0e0a-1b9740683449' },
            {
                name: DeviceCharacteristic_1.VapingCharacteristics.POD_CONNECTION_DETECTION,
                uuid: '6cd6c8b5-e378-0109-0f0a-1b9740683449',
            },
            {
                name: DeviceCharacteristic_1.VapingCharacteristics.POWER_SAVER_MODE,
                uuid: '6cd6c8b5-e378-0106-100a-1b9740683449',
            },
        ],
    },
    LOG: {
        name: 'Logging Service',
        uuid: '6cd6c8b5-e378-0109-000b-1b9740683449',
        characteristics: [
            { name: 'LAST_ERROR', uuid: '6cd6c8b5-e378-0109-010b-1b9740683449' },
            { name: 'LOG_RECORD', uuid: '6cd6c8b5-e378-0109-030b-1b9740683449' },
        ],
    },
    DFU: {
        name: 'Firmware Update Service',
        uuid: '0000fe59-0000-1000-8000-00805f9b34fb',
        characteristics: [
            { name: 'BUTTON_LESS', uuid: '8ec90004-f315-4f60-9fb8-838830daea50' },
            { name: 'CONTROL_POINT', uuid: '8ec90001-f315-4f60-9fb8-838830daea50' },
            { name: 'DFU_PACKET', uuid: '8ec90002-f315-4f60-9fb8-838830daea50' },
        ],
    },
    DEVICE_MANAGEMENT: {
        name: 'Device Management',
        uuid: '6cd6c8b5-e378-0109-000c-1b9740683449',
        characteristics: [
            { name: 'VERSION', uuid: '6cd6c8b5-e378-0109-010c-1b9740683449' },
            { name: 'CONTROL', uuid: '6cd6c8b5-e378-0109-020c-1b9740683449' },
            { name: 'PAYLOAD', uuid: '6cd6c8b5-e378-0109-030c-1b9740683449' },
            { name: 'CHALLENGE', uuid: '6cd6c8b5-e378-0109-040c-1b9740683449' },
        ],
    },
    AV_SERVICE: {
        name: 'Age Verification Service',
        uuid: '6CD6C8B5-E378-0109-000D-1B9740683449',
        characteristics: [
            { name: 'Challenge Generation', uuid: '6CD6C8B5-E378-0109-010D-1B9740683449' },
            { name: 'Signature Verification', uuid: '6CD6C8B5-E378-0109-020D-1B9740683449' },
        ],
    },
};
var SmartBoxDevice = /** @class */ (function (_super) {
    __extends(SmartBoxDevice, _super);
    function SmartBoxDevice() {
        return _super.call(this, SmartBoxProfile, 'SmartBox') || this;
    }
    SmartBoxDevice.prototype.toggleFindMyVape = function (value, soundPattern) {
        if (soundPattern === void 0) { soundPattern = sound_pattern_enum_1.SoundPatternEnum.CRESCENT; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, _super.prototype.toggleFindMyVape.call(this, value, soundPattern)];
            });
        });
    };
    SmartBoxDevice.prototype.setLockConfig = function (value, withResponse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!value.outOfRange) {
                    value.outOfRange = false;
                }
                if (!withResponse)
                    withResponse = true;
                return [2 /*return*/, _super.prototype.setLockConfig.call(this, value, withResponse)];
            });
        });
    };
    return SmartBoxDevice;
}(BatDevice_1.default));
exports.SmartBoxDevice = SmartBoxDevice;
exports.SmartBox = new SmartBoxDevice();
exports.SmartBoxInfo = SmartBoxProfile;
